/*
const routerConfig = {
  baseUrl: '/exchangeCar/',
  router: [
    {
      path: '/ExchangeCarIndex.html',
      name: 'Index',
      component: resolve => require(['@/pages/ChangeCar/Index'], resolve),
      meta: {
        title: '换车',
        keepAlive: true
      }
    },
    {
      path: '/ExchangeCarResult.html',
      name: 'Result',
      component: resolve => require(['@/pages/ChangeCar/changeCarResult'], resolve),
      meta: {
        title: '换车优惠价查看',
        keepAlive: false
      }
    },
    {
      path: '/SalesDetails.html',
      name: 'SalesDetails',
      component: resolve => require(['@/pages/SalesCar/Details'], resolve),
      meta: {
        title: '服务进度详情',
        keepAlive: false
      }
    }
  ]
}

卖换估详情页
const routerConfig = {
  baseUrl: '/TopicApp/2021/salescar/',
  router: [
    {
      path: '/details',
      name: 'SalesDetails',
      component: resolve => require(['@/pages/SalesCar/Details'], resolve),
      meta: {
        title: '服务进度详情',
        keepAlive: true
      }
    }
  ]
}
*/
// 估值
const routerConfig = {
  // baseUrl: '/2022/valuation/',
  baseUrl: '/TopicApp/2021/valuation0701/',
  router: [
    {
      path: '/index',
      name: 'index',
      component: resolve => require(['@/pages/Valuation/index'], resolve),
      meta: {
        title: '估值',
        keepAlive: false
      }
    },
    {
      path: '/report',
      name: 'report',
      component: resolve => require(['@/pages/Valuation/report'], resolve),
      meta: {
        title: '估值报告',
        keepAlive: false
      }
    }
  ]
}
export default routerConfig;


// WEBPACK FOOTER //
// ./src/router/routerConfig.js